import { Handle, Position } from '@xyflow/react';
import { Repeat } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function ForEachNode({ id, data, selected }) {
  const varName = data.itemVariable || 'item';
  const summary = data.collectionRef
    ? `Loop as {{${varName}}}`
    : null;

  const outputHandles = (
    <>
      <Handle
        type="source"
        position={Position.Bottom}
        id="loop"
        className="!w-3 !h-3 !bg-amber-500 !border-2 !border-white"
        style={{ left: '35%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="done"
        className="!w-3 !h-3 !bg-green-500 !border-2 !border-white"
        style={{ left: '65%' }}
      />
      <div className="flex justify-between px-6 pb-1">
        <span className="text-[9px] text-amber-600 font-medium">Loop</span>
        <span className="text-[9px] text-green-600 font-medium">On Finish</span>
      </div>
    </>
  );

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.logic}
      icon={Repeat}
      label={data.label}
      outputHandles={outputHandles}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
      {data.collectionRef && (
        <span className="inline-block mt-1 text-[10px] font-mono font-medium bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
          {`{{${varName}}}`}
        </span>
      )}
    </BaseNode>
  );
}
